mutation acceptLegalConsents($companyId: ID!, $items: [AcceptLegalConsentInput!]!) {
  acceptLegalConsents(companyId: $companyId, items: $items) {
    identifier
    acceptedAt
  }
}
